import React, { useEffect, useRef, useState } from "react";
import downloadIcon from "../../../../asset/images/download-arrow.svg";
import downIcon from "../../../../asset/images/download-blue-arrow.svg";
import attachIcon from "../../../../asset/images/attach.svg";
import { toast } from "react-toastify";
import SmallLoader from "../../../../Components/Common/smallLoader";
import { decryptData, handleAlphaSpaceChange, toSentenceCase } from "../../../../CommonMethhods/CommonMethods";
import axiosInstance, { axiosMultipart1 } from "../../../../CommonMethhods/axiosInstance";
import { Dealer_Mapping } from "../../../../Configuration/API_URL";
import uploadIcon from "../../../../asset/images/upload-file.svg";
import closeIcon from "../../../../asset/images/close-gray.svg";

function UploadFile({ onUpload, selectedRequest, isFromMyRequest, rowData }) {
  const [submitLoader, setSubmitLoader] = useState(false);
  const mappingFileRef = useRef(null);
  const approvalFileRef = useRef(null);
  const [docLoader, setDocLoader] = useState(false)
  const [mappingFile, setMappingFile] = useState(null);
  const [approvalDoc, setApprovalDoc] = useState(null);
  const [batchId, setBatchId] = useState("");
  const [approvalDocLink, setApprovalDocLink] = useState("");
  // Batch-level reason, mirroring the single mapping request screen.
  const [reasonType, setReasonType] = useState("");
  // const [reason, setReason] = useState("");
  const [remarks, setRemarks] = useState("");
  // Set once the maker has typed in Remarks, so an emptied box can say it is
  // required without showing the error on a form nobody has touched yet.
  const [remarksTouched, setRemarksTouched] = useState(false);
  // const reasonTextareaRef = useRef(null);

  const handleMappingUploadClick = () => {
    mappingFileRef.current?.click();
  };

  const handleApprovalUploadClick = () => {
    approvalFileRef.current?.click();
  };

  // Only .xlsx is accepted for the dealer mapping template - unlike the
  // shared validateFileExcel helper, which also allows .xls/.csv for other
  // bulk upload flows.
  const validateMappingFile = (file) => {
    const isValidSize = file.size / 1024 / 1024 <= 5;
    if (!isValidSize) {
      toast.error("File size must be less than or equal to 5MB");
      return false;
    }
    if (!file.name.toLowerCase().endsWith(".xlsx")) {
      toast.error("Only .xlsx files are allowed");
      return false;
    }
    return true;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!validateMappingFile(file)) {
      e.target.value = "";
      return;
    }

    setMappingFile(file);
  };
  console.log(rowData, "rowDataBulk");

  const hasApprovalDoc = approvalDoc || approvalDocLink;
  const hasMappingFile = mappingFile;

  // const reasonLength = reason.trim().length;
  // const pendingMinChars = Math.max(0, 10 - reasonLength);
  // const remainingChars = 500 - reasonLength;
  const remarksLength = remarks.trim().length;
  const remainingRemarkChars = 500 - remarks.length;

  // Remarks are the only explanation a maker gives for any reason type, so
  // they need a minimum length whichever type is picked.
  // const pendingMinChars =
  //   reasonType === "others" ? Math.max(0, 10 - remarksLength) : 0;
  const pendingMinChars = Math.max(0, 10 - remarksLength);
  // The minimum-length message only appears once the maker starts typing; an
  // empty box gets "Remarks is required" instead, never both together.
  const showMinCharsMsg = remarksLength > 0 && pendingMinChars > 0;

  // "Others" needs the free-text reason; the two preset reasons stand alone.
  // const hasReason =
  //   !!reasonType && (reasonType !== "others" || reasonLength >= 10);
  // const hasRemarks = !!remarks.trim();
  // const hasReason = !!reasonType;
  // const hasRemarks = remarksLength > 0 && pendingMinChars === 0;

  // A reopened draft / sent back batch already has its rows (and usually its
  // reason, remarks and document) on the server, so it can go straight to the
  // results step without picking the file again or changing anything.
  const isReopened = isFromMyRequest && !!selectedRequest?.batchId;
  const existingRowCount = rowData?.requests?.length || 0;
  const canReuseRows = isReopened && existingRowCount > 0;

  // const hasReason = !!reasonType || isReopened;
  // const hasRemarks = isReopened
  //   ? // Left blank (or not returned by the backend) is fine when untouched;
  //     // anything typed still has to meet the minimum, and an emptied box is
  //     // reported as required.
  //     remarksLength === 0
  //     ? !remarksTouched
  //     : pendingMinChars === 0
  //   : remarksLength > 0 && pendingMinChars === 0;
  // A reopened draft / sent back batch gets no leniency: reason and remarks
  // (prefilled for a draft, blank for a sent back batch) must be filled in.
  const hasReason = !!reasonType;
  const hasRemarks = remarksLength > 0 && pendingMinChars === 0;

  // The batch number is stamped by the backend, so it only has a value when a
  // saved draft is reopened.
  const batchReference = selectedRequest?.batchId || batchId;

  const reasonOptions = [
    { value: "newMapping", label: "New mapping" },
    { value: "updateMapping", label: "Update existing mapping" },
    { value: "others", label: "Others" },
  ];

  // useEffect(() => {
    // if (reasonType === "others") {
      // setTimeout(() => {
        // reasonTextareaRef.current?.focus();
      // }, 0);
    // }
  // }, [reasonType]);

  useEffect(() => {
    if (!isFromMyRequest || !rowData) return;
    setApprovalDocLink(rowData?.approvalDocLink || "");
  }, [rowData, isFromMyRequest]);

  // Show what the maker entered the first time round, so a reopened batch is
  // not presented as blank. Only fills what is still empty.
  useEffect(() => {
    if (!isFromMyRequest || !rowData) return;

    // The batch-level reason / remarks come back either on the batch details
    // or on the dashboard row (selectedRequest), same as the view pages read them.
    const savedRemarks = rowData?.remarks || selectedRequest?.remarks;
    // const savedReason = (rowData?.reason || "").trim();
    const savedReason = (rowData?.reason || selectedRequest?.reason || "").trim();
    if (savedReason) {
      setReasonType((current) => {
        if (current) return current;
        if (savedReason.toLowerCase() === "new mapping") return "newMapping";
        if (savedReason.toLowerCase() === "update existing mapping") return "updateMapping";
        return "others";
      });
    }

    // A sent back batch opens with an empty Remarks box; the maker writes
    // fresh remarks for the resubmission.
    // The backend spells it several ways (sendback, send back, send_back,
    // sent_back ...), so the status is compared with spaces, "_" and "-" removed.
    // const isSendBack = selectedRequest?.status?.toLowerCase() === "sendback";
    const normalizedStatus = String(
      selectedRequest?.status ||
      rowData?.status ||
      rowData?.requests?.[0]?.approvalStatus ||
      ""
    )
      .toLowerCase()
      .replace(/[\s_-]/g, "");
    const isSendBack = ["sendback", "sentback"].includes(normalizedStatus);
    // if (rowData?.remarks && !isSendBack) {
    //   setRemarks((current) => current || rowData.remarks);
    // }
    if (savedRemarks && !isSendBack) {
      setRemarks((current) => current || savedRemarks);
    }
  }, [rowData, isFromMyRequest]);

  const supportingDocName = approvalDocLink
    ? decodeURIComponent(
      approvalDocLink
        .split("/")
        .pop()
        .split("?")[0]
    )
    : "";

  const handleApprovalFileChange = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const validTypes = [
      ".pdf",
      ".jpg",
      ".jpeg",
      ".png",
      ".bmp",
    ];

    const isValid = validTypes.some((type) =>
      file.name.toLowerCase().endsWith(type)
    );

    if (!isValid) {
      toast.error(
        "Only PDF/JPG/JPEG/PNG/BMP files are allowed"
      );
      e.target.value = "";
      return;
    }

    // The backend validates the picked file (e.g. password-protected PDF) and its
    // message is shown as-is, same as the single request screen.
    try {
      const fileData = new FormData();
      fileData.append("approval-doc", file);
      const validateResp = await axiosMultipart1.post(Dealer_Mapping.validateApprovalDoc, fileData);
      const validated = JSON.parse(decryptData(validateResp?.data));
      if (validated?.status !== 0) {
        toast.error(validated?.message);
        e.target.value = "";
        return;
      }
    } catch (error) {
      let catchResp = null;
      try {
        catchResp = JSON.parse(decryptData(error?.response?.data));
      } catch (parseError) {
        catchResp = null;
      }
      if (catchResp?.message) {
        toast.error(catchResp.message);
        e.target.value = "";
        return;
      }
      // No usable backend response: let the file through, submit validates it again.
    }
    setApprovalDoc(file);
  };

  const downlodDocument = async () => {
    setDocLoader(true);

    try {
      const getDetails = await axiosInstance.get(
        Dealer_Mapping.bulkDownloadTemplate,
      );

      const decrypted = JSON.parse(
        decryptData(getDetails?.data)
      );

      if (decrypted?.status === 0) {
        // toast.success(decrypted?.message);
        // The backend's message says the template was "generated"; the maker
        // is downloading it, so the wording is set here.
        toast.success("Template Downloaded Successfully");
        window.open(decrypted?.data?.url, "_self", "noopener,noreferrer");
      } else {
        toast.error(decrypted?.message);
      }
    } catch (error) {
      console.log(error);

    } finally {
      setDocLoader(false);
    }
  };

  const handleValidatePreview = async () => {
    // Nothing new to upload on a reopened batch: its rows are already on the
    // server, so move on to the results step with what it holds.
    if (!mappingFile && canReuseRows) {
      // onUpload({
      //   batchId: selectedRequest?.batchId,
      //   totalRows: existingRowCount,
      //   validRows: existingRowCount,
      //   failedRows: 0,
      //   fileName: selectedRequest?.fileName || rowData?.fileName,
      // });
      // Every row is not necessarily valid: the batch keeps each row's own
      // validityStatus / failureReason from the upload, so the counts and the
      // failed rows are read back from them. A row with no status at all
      // (an older response) is treated as valid.
      const rows = rowData?.requests || [];
      const isRowValid = (row) =>
        !row?.validityStatus || String(row.validityStatus).toLowerCase() === "valid";
      const failedRows = rows.filter((row) => !isRowValid(row));

      onUpload({
        batchId: selectedRequest?.batchId,
        totalRows: rows.length,
        validRows: rows.length - failedRows.length,
        failedRows: failedRows.length,
        failedDetails: failedRows.map((row) => ({
          clientCode: row?.ucc,
          failures: (Array.isArray(row?.failureReason)
            ? row.failureReason
            : [row?.failureReason]
          ).filter(Boolean),
          reason: row?.reason,
          remarks: row?.remarks,
        })),
        fileName: selectedRequest?.fileName || rowData?.fileName,
      });
      return;
    }

    validateBulkData()
  };

  const validateBulkData = async () => {
    setSubmitLoader(true);
    const formData = new FormData();
    formData.append("file", mappingFile);
    // Only a newly picked file is sent. On a reopened draft the saved document
    // is already on the batch, and hasApprovalDoc would be its link string.
    if (approvalDoc instanceof File) {
      formData.append("approval-doc", approvalDoc);
    }

    // Batch-level fallback only: the backend applies it to rows whose "Reason
    // for Change" cell is blank, so the per-row column stays authoritative.
    // Keyed separately from `reason` so the two cannot be confused.
    const finalReason =
      reasonType === "newMapping"
        ? "New mapping"
        : reasonType === "updateMapping"
          ? "Update existing mapping"
          // : reason;
          : reasonType === "others"
            ? "Others"
            : "";

    if (finalReason) {
      formData.append("batch-reason", finalReason);
    }

    formData.append("batch-remarks", remarks);


    try {
      let url = "";
      let response;

      if (isFromMyRequest) {
        url = `${Dealer_Mapping.singleMappingSubmit}/${selectedRequest?.batchId}/submit?draft=true`;

        response = await axiosMultipart1.put(url, formData);
      } else {
        url = `${Dealer_Mapping.bulkValidate}?draft=true`;

        response = await axiosMultipart1.post(url, formData);
      }

      const decryptedresp = decryptData(response.data);
      const decrypted = JSON.parse(decryptedresp)

      console.log(decrypted, "decryptedbulk");

      if (decrypted?.status === 0) {
        setBatchId(decrypted?.data?.batchId)
        toast.success(decrypted.message);
        // fileName comes back empty until the DB migration lands, so the
        // uploaded name is passed through as a fallback. Drop this once the
        // response is populated.
        onUpload({
          ...decrypted.data,
          fileName: decrypted?.data?.fileName || mappingFile?.name,
        });
      } else {
        toast.error(decrypted.message);
      }
    } catch (error) {
      const decryptedResp = decryptData(error?.response?.data);
      const decryptedError = JSON.parse(decryptedResp);
      toast.error(decryptedError?.message)
      console.log(decryptedError);
    } finally {
      setSubmitLoader(false);
    }
  };

  const clearFile = (type) => {
    if (type?.toLowerCase() === "mapping") {
      setMappingFile(null);

      if (mappingFileRef.current) {
        mappingFileRef.current.value = "";
      }
    }

    if (type?.toLowerCase() === "approval") {
      setApprovalDoc(null);
      setApprovalDocLink("");

      if (approvalFileRef.current) {
        approvalFileRef.current.value = "";
      }
    }
  };


  const handleClear = () => {
    clearFile("mapping");
    clearFile("approval");
    setReasonType("");
    // setReason("");
    setRemarks("");
    setRemarksTouched(false);
  };

  // "partial" is the same state as "pending" for the maker, so it is shown as Pending.
  const getStatusClass = (status = "") => {
    switch (status.toLowerCase()) {
      case "pending":
      case "partial":
        return "status-pending";
      case "approved":
        return "status-approved";
      case "rejected":
        return "status-rejected";
      case "draft":
        return "status-draft";
      case "sendback":
        return "status-sendback";
      default:
        return "";
    }
  };

  const handlePreviewApprovalDoc = () => {
    if (approvalDoc instanceof File) {
      const fileUrl = URL.createObjectURL(approvalDoc);
      window.open(fileUrl, "_blank", "noopener,noreferrer");

      setTimeout(() => URL.revokeObjectURL(fileUrl), 1000);
      return;
    }
    if (approvalDocLink) {
      window.open(approvalDocLink, "_blank", "noopener,noreferrer");
    }
  };

  const handlePreviewMappingFile = () => {
    if (!mappingFile) return;

    const fileUrl = URL.createObjectURL(mappingFile);
    window.open(fileUrl, "_blank", "noopener,noreferrer");

    setTimeout(() => URL.revokeObjectURL(fileUrl), 1000);
  };

  return (
    <>
      <div className="wrap-downloads">
        <div className="content-icon">
          <div className="wrap-icon">
            <img src={downloadIcon} alt="icon" />
          </div>
          <div className="download-text">
            <span className="down-temp">Download Template</span>
            <span className="col-text">Pre-formatted Excel with correct headers · Do not alter headers</span>
          </div>
        </div>

        <div className="wrap-down-btn"
          tabIndex={0}
          role="button"
          onClick={downlodDocument}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              downlodDocument();
            }
          }}>
          {docLoader ?
            <SmallLoader />
            :
            <>
              <img src={downIcon} alt="download-icon" />
              <button className="download-template">Download</button>
            </>
          }
        </div>
      </div>

      <div className="wrap-bulk-section">
        <div className="batch-upload-wrapper">
          <div className="step-content upload-box-width">
            <div className="upload-box new-mapping-content">

              <div className="wrap-file-upload">
                {selectedRequest?.batchId ?

                  <div className="wrap-title-batch">
                    <div className="status-content">
                      <span className="ckr-section-title">{selectedRequest?.batchId}</span>
                      {selectedRequest?.status !== "" ?
                        <span className={getStatusClass(selectedRequest?.status)}>
                          {selectedRequest?.status?.toLowerCase() === "sendback"
                            ? "Send Back"
                            : toSentenceCase(selectedRequest?.status)}
                        </span>
                        : "-"}
                    </div>
                    <span className="upload-text">Upload Mapping File <span className="error-mark">*</span></span>
                    {/* Empty until SP_GET_MAKER_APPLICATIONS returns it. */}
                    {selectedRequest?.fileName && (
                      <span className="upload-info">
                        Last uploaded: {selectedRequest.fileName}
                      </span>
                    )}
                  </div>

                  :
                  <span className="upload-text">Upload Mapping File <span className="error-mark">*</span></span>
                }

                {mappingFile ?
                  <div className="dealer-doc-upload">

                    <div className="wrap-upload-section"
                    >
                      <div className="wrap-docname">
                        <img src={uploadIcon} alt="upload icon" />

                        <span className="upload-doc-btn" onClick={handlePreviewMappingFile}>
                          {mappingFile?.name}
                        </span>
                      </div>

                      <img
                        className="close"
                        src={closeIcon}
                        alt="close"
                        style={{ cursor: "pointer" }}
                        onClick={() => clearFile("mapping")}
                      />
                      <input
                        type="file"
                        style={{ display: "none" }}
                        accept=".xlsx"
                      />
                    </div>

                  </div>
                  :

                  <div className="wrap-drag-drop"
                    tabIndex={0}
                    role="button"
                    onClick={handleMappingUploadClick}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleMappingUploadClick();
                      }
                    }}>

                    <div className="upload-area">
                      <img src={attachIcon} alt="attach icon" />

                      <div className="wrap-input-cont">
                        <span className="drag-text">Drop approval document here</span>
                        <span className="upload-info">
                          .xlsx · Max 5,000 rows· Max 5 MB
                        </span>
                        <input
                          type="file"
                          ref={mappingFileRef}
                          hidden
                          accept=".xlsx"
                          id="fileUpload"
                          onChange={handleFileChange}
                        />
                        <label className="select-file bold-text">Select File</label>
                      </div>
                    </div>
                  </div>
                }
              </div>

            </div>

          </div>

          <div className="wrap-preview-section">

            <div className="step-content mb-extra">
              <div className="preview-wrapper">

                <div className="summary-title-wrap batch-wrap">
                  <span className="summary-title">Batch Details</span>
                </div>

                <div className="title-ref-sec">
                  <span className="ref">Batch Reference</span>
                  <div className="batch-section">
                    <span>
                      {batchReference
                        ? `${batchReference} (auto-generated)`
                        : "Auto-generated on submit"}
                    </span>
                  </div>
                </div>

                <div className="title-batch">
                  <span className="ref">Batch Approval Document <span className="error-mark">*</span></span>
                  {!approvalDoc && !approvalDocLink ?
                    <>
                      <div className="wrap-drag-drop branch-doc-wrap" tabIndex={0}
                        role="button"
                        onClick={handleApprovalUploadClick}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            handleApprovalUploadClick();
                          }
                        }}>

                        <div className="upload-area">


                          <div className="wrap-input-cont">
                            <span className="drag-text">Attach batch approval</span>
                            <input
                              type="file"
                              ref={approvalFileRef}
                              hidden
                              accept=".pdf,.jpg,.jpeg,.png,.bmp"
                              id="fileUpload"
                              onChange={handleApprovalFileChange}

                            />
                          </div>
                          <img src={attachIcon} alt="attach icon" />
                        </div>
                      </div>
                      <span className="upload-batch-info">
                        Maximum file size: 5 MB, PDF/JPG/JPEG/PNG/BMP
                      </span>
                    </>
                    :
                    <div className="dealer-doc-upload">

                      <div className="wrap-upload-section"
                      >
                        <div className="wrap-docname">
                          <img src={uploadIcon} alt="upload icon" />

                          <span className="upload-doc-btn" onClick={handlePreviewApprovalDoc}>
                            {approvalDoc?.name || rowData?.approvalDocFilename}
                          </span>
                        </div>

                        <img
                          className="close"
                          src={closeIcon}
                          alt="close"
                          style={{ cursor: "pointer" }}
                          onClick={() => clearFile("approval")}
                        />
                        <input
                          type="file"
                          style={{ display: "none" }}
                          accept=".pdf,.jpg,.png,.jpeg,.bmp"
                        />
                      </div>

                    </div>
                  }
                </div>

                <div className="title-reason-sec">
                  <span className="ref">Reason for Change <span className="error-mark">*</span></span>

                  <div
                    className="wrap-radio-section"
                    role="radiogroup"
                    aria-label="Reason for change"
                  >
                    {reasonOptions.map((option) => (
                      <label className="radio-option" key={option.value}>
                        <input
                          type="radio"
                          name="batchReasonType"
                          value={option.value}
                          checked={reasonType === option.value}
                          onChange={(e) => {
                            setReasonType(e.target.value);
                            // if (e.target.value !== "others") {
                            //   setReason("");
                            // }
                            // Remarks are written for one reason type, so
                            // picking another starts them afresh.
                            setRemarks("");
                            setRemarksTouched(false);
                          }}
                        />
                        <span>{option.label}</span>
                      </label>
                    ))}
                  </div>

                  {/*
                  {reasonType === "others" &&
                    <>
                      <textarea
                        ref={reasonTextareaRef}
                        maxLength={500}
                        className="batch-reason-input"
                        placeholder="Type reason here"
                        value={reason}
                        onChange={(e) =>
                          handleAlphaSpaceChange(
                            e,
                            "reason",
                            (_, value) => setReason(value),
                            500
                          )
                        }
                      />

                      <div className="char-count">
                        {pendingMinChars > 0 ? (
                          <span className="ErrorMsg">
                            Minimum {pendingMinChars} character
                            {pendingMinChars > 1 ? "s are" : " is"} required
                            ({reasonLength}/500)
                          </span>
                        ) : (
                          <span>{remainingChars} characters remaining</span>
                        )}
                      </div>
                    </>
                  }
                  */}
                </div>

                <div className="title-reason-sec">
                  <span className="ref">Remarks <span className="error-mark">*</span></span>

                  <textarea
                    maxLength={500}
                    className="batch-reason-input"
                    placeholder="Type remarks here"
                    value={remarks}
                    onChange={(e) =>
                      handleAlphaSpaceChange(
                        e,
                        "remarks",
                        (_, value) => {
                          setRemarks(value);
                          setRemarksTouched(true);
                        },
                        500
                      )
                    }
                  />

                  <div className="char-count">
                    {/* <span>{remainingRemarkChars} characters remaining</span> */}
                    {/* {pendingMinChars > 0 ? ( */}
                    {showMinCharsMsg ? (
                      // <span className="ErrorMsg">
                      //   Minimum {pendingMinChars} character
                      //   {pendingMinChars > 1 ? "s are" : " is"} required
                      //   ({remarksLength}/500)
                      // </span>
                      <span className="ErrorMsg">
                        Minimum 10 characters are required
                      </span>
                    ) : (
                      <span>{remainingRemarkChars} characters remaining</span>
                    )}
                  </div>

                  {remarksTouched && remarksLength === 0 && (
                    <span className="ErrorMsg">Remarks is required</span>
                  )}
                </div>
              </div>

            </div>

          </div>
        </div>
        <div className="format-table-section">
          <div className="ckr-section-header">
            <p className="ckr-section-title">File Format Guide</p>
          </div>
          <div className="ckr-table-wrapper scroll-table format-guide-table">
            <table className="ckr-table draft-maker">
              <thead>
                <tr>
                  <th>Column</th>
                  <th>Required?</th>
                  <th>Example</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Client Code</td>
                  <td>Required</td>
                  <td>00547</td>
                </tr>
                <tr>
                  <td>New Dealer Code</td>
                  <td>Required</td>
                  <td>487874</td>
                </tr>
                <tr>
                  <td>Effective Date</td>
                  <td>Required</td>
                  <td>2026-01-15</td>
                </tr>
                <tr>
                  <td>Branch</td>
                  <td>Required</td>
                  <td>PUNE1</td>
                </tr>
                <tr>
                  <td>Reason for Change</td>
                  <td>Required</td>
                  <td>New Mapping</td>
                </tr>
                <tr>
                  <td>Remarks</td>
                  <td>Required</td>
                  <td>For Better Service</td>
                </tr>
                <tr>
                  <td>Request Date</td>
                  <td>Auto-filled</td>
                  <td>Set to the date you upload the file</td>
                </tr>
                <tr>
                  <td>Client Name</td>
                  <td>Optional</td>
                  <td>Looked up from the client master</td>
                </tr>
                <tr>
                  <td>Old Dealer Code</td>
                  <td>Optional</td>
                  <td>The client's current dealer (blank = new)</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="mapping-footer-actions">
        <button
          className={`back-btn ${!hasMappingFile && !hasApprovalDoc && !reasonType && !remarks ? "disabled-btn-back" : ""
            }`}
          onClick={handleClear}
          disabled={!hasMappingFile && !hasApprovalDoc && !reasonType && !remarks}
        >
          Clear
        </button>
        <button
          // className={`submit-btns ${!hasMappingFile || !hasApprovalDoc || !hasReason || !hasRemarks ? "disabled-btn" : ""
          //   }`}
          // className={`submit-btns ${(!hasMappingFile && !canReuseRows) || !hasApprovalDoc || !hasReason || !hasRemarks ? "disabled-btn" : ""
          //   }`}
          className={`submit-btns ${!hasMappingFile || !hasApprovalDoc || !hasReason || !hasRemarks ? "disabled-btn" : ""
            }`}
          onClick={handleValidatePreview}
          // disabled={(!hasMappingFile && !canReuseRows) || !hasApprovalDoc || !hasReason || !hasRemarks}
          disabled={!hasMappingFile || !hasApprovalDoc || !hasReason || !hasRemarks}
        >
          {submitLoader ?
            <SmallLoader />
            : <>
              Validate & Preview
            </>}

        </button>
      </div>
    </>
  );
}

export default UploadFile;
